//
import CustomerModel from '@/models/Sale/SlCustomer'
import findById from './findById'
// import toggleCustomerBlock from './blockUnblockCustomer'
import blockUnblockCustomer from './blockUnblockCustomer'

//
const includes = [
    'sl_ground_seller.hr_employee',
    'pch_payment_condition',
]

/**
 *
 */
const fetchAll = async () => {
    try {
        const response = await CustomerModel.params({ get_all_results: true }).include( includes ).get()
        return response.data
    } catch (error) {
        return error.response.data
    }
}

//
export default {
    fetchAll,
    findById,
    blockUnblockCustomer,
}
